import React, { useState, useEffect, useContext } from "react";
import { Card, Col, Row, Table, Spinner, Form, Button, Container, Modal} from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import authenticatedFetch from "../../utils/fetch"
import { Trash2, ExternalLink} from "react-feather";
import EditableExpires from "../../utils/EditableExpires";
import NotyfContext from "../../contexts/NotyfContext";
import { UserSettingsContext } from "../../contexts/UserSettingsContext";
import Select from "react-select";

import InputMask from "react-input-mask";
import AvailableESignatureTemplates from "../../utils/AvailableESignatureTemplates";
import ReminderPreferenceAssignment from "../../utils/ReminderPreferenceAssignment";
import TaskAssigneeSelect from "../../utils/TaskAssigneeSelect";

import {Send, UserPlus, Clipboard} from "react-feather";


const ProviderBasicFields = ({npi, setNpi, firstName, setFirstName, middleName, setMiddletName, lastName, setLastName, credentials, setCredentials, email, setEmail, sendOnboardingForms}) => {
  const handleNpiChanged = (value) => {
    setNpi(value.replace(/_/g, ''));
  }

  if (email == null)
  {
    email = "";
  }
  if (firstName == null)
  {
    firstName = "";
  }
  if (middleName == null)
  {
    middleName = "";
  }
  if (lastName == null)
  {
    lastName = "";
  }
  if (npi == null)
  {
    npi = "";
  }
  if (credentials == null)
  {
    credentials = "";
  }
  

  return (
    <Card>
      <Card.Header style={{marginBottom: '-15px'}}>
        <Card.Title>
        Personal Details
        </Card.Title>
      </Card.Header>
      <Card.Body>
    <Table>
      <tbody>
        <tr>
          <td style={{width: "160px"}}>Personal Email{sendOnboardingForms ? "*" : ""}:</td>
          <td><Form.Control type="input" value={email} onChange={(e) => {setEmail(e.target.value)}}/></td>
        </tr>
        <tr>
          <td>First Name*:</td>
          <td><Form.Control type="input" value={firstName} onChange={(e) => {setFirstName(e.target.value)}}/></td>
        </tr>
        <tr>
          <td>Middle Name:</td>
          <td><Form.Control type="input" value={middleName} onChange={(e) => {setMiddletName(e.target.value)}}/></td>
        </tr>
        <tr>
          <td>Last Name*:</td>
          <td><Form.Control type="input" value={lastName} onChange={(e) => {setLastName(e.target.value)}}/></td>
        </tr>
        <tr>
          <td>NPI:</td>
          <td>
            <InputMask
              mask="9999999999"
              value={npi} 
              onChange={(e) => {handleNpiChanged(e.target.value)}} >
              {(inputProps) => <Form.Control {...inputProps} type="text" />}
          </InputMask>
          </td>
        </tr>
        <tr>
          <td>Credentials:</td>
          <td><Form.Control type="input" value={credentials} onChange={(e) => {setCredentials(e.target.value)}}/></td>
        </tr>
      </tbody>
    </Table>
    </Card.Body>
    <br />
  </Card>
  )
}


const ProviderOnboarding = ({sendOnboardingForms, setSendOnboardingForms, onESignatureTemplatesChanged, createInitialEnrollmentTasks, setCreateInitialEnrollmentTasks, createPsvTasks, setCreatePsvTasks, canEdit, isCreate}) => {
  return (
    <Card>
      <Card.Header style={{marginBottom: '-15px'}}>
        <Card.Title>
        Onboarding / Initial Build
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Form.Label><Form.Check type="switch" checked={sendOnboardingForms} style={{display: "inline"}}  onChange={(e) => {setSendOnboardingForms(e.target.checked)}}/>&nbsp;&nbsp;Send Onboarding Link</Form.Label>
        <br />
        {sendOnboardingForms && <><AvailableESignatureTemplates pathPrefix="admin/provider" onESignatureTemplatesChanged={onESignatureTemplatesChanged} canEdit={canEdit}/><br /></>}
        {!isCreate &&
        <>
        <Form.Label><Form.Check type="switch" checked={createInitialEnrollmentTasks} style={{display: "inline"}}  onChange={(e) => {setCreateInitialEnrollmentTasks(e.target.checked)}}/>&nbsp;&nbsp;Create Initial Enrollment Tasks</Form.Label>
        <br />
        <Form.Label><Form.Check type="switch" checked={createPsvTasks} style={{display: "inline"}}  onChange={(e) => {setCreatePsvTasks(e.target.checked)}}/>&nbsp;&nbsp;Create PSV Tasks</Form.Label>
        </>
        }
      </Card.Body>
  </Card>
  )
}


const AvailableHub= ({ id, name, isActive, onChange, canEdit }) => {
  const [localIsActive, setLocalIsActive] = useState(isActive);

  const handleIsActiveChanged = (e) => {
    setLocalIsActive(e.target.checked);
    onChange(id, e.target.checked);
  }

  return (
    <tr>
        <td>{name}</td>
        <td><Form.Check checked={localIsActive} disabled={!canEdit} onChange={(e) => {handleIsActiveChanged(e)}} />  </td>
        <td>{isActive && !localIsActive && <span className="text-warning" style={{fontSize: '0.85em'}}>Provider's portal login credentials will also be deleted!</span>}</td>
    </tr>
  );
}

const ProviderHubAssignment = ({providerId, onHubChanged, canEdit, refresh}) => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    authenticatedFetch({
      path: providerId && providerId > 0 ? "admin/provider/hubs/" + providerId : "admin/provider/hubs/",
      successHandler: function(result) {
        setIsLoaded(true);
        setData(result);

        for (var i = 0; i < result.length; i++)
        {
          onHubChanged(result[i].id, result[i].isActive);
        }
      },
      errorHandler: function(error) {
        setIsLoaded(true);
        setError(error);
      }
    });
  }, [providerId, refresh])

  var hubList;

  if (error)
  {
    hubList = <tr><td colSpan="4">Error... please try again...</td></tr>;
  }
  else if (!isLoaded)
  {
    hubList = <tr><td colSpan="4">Loading...</td></tr>;
  }
  else if (!data || data.length === 0)
  {
    hubList = <tr><td colSpan="4">No hubs found...</td></tr>;
  }
  else
  {
    hubList = data.map((hub) => {
      return (
        <AvailableHub key={hub.id} id={hub.id} name={hub.name} isActive={hub.isActive} onChange={onHubChanged} canEdit={canEdit}/>
      )
    }, this);
  }

  return (
    <Card>
      <Card.Header style={{marginBottom: '-15px'}}>
        <Card.Title>
        Data Hubs
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Table striped hover>
          <thead>
            <tr>
              <td>Name</td>
              <td>Active</td>
              <td style={{width: '150px'}}>&nbsp;</td>
            </tr>
          </thead>
          <tbody>
            {hubList}
          </tbody>
        </Table>
      </Card.Body>
  </Card>
  )
}


const ProviderOnboardingUrl = ({providerId, sendOnboardingForms, setSendOnboardingForms, onESignatureTemplatesChanged, createInitialEnrollmentTasks, setCreateInitialEnrollmentTasks, createPsvTasks, setCreatePsvTasks, canEdit, refresh}) => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    authenticatedFetch({
      path: "admin/provider/onboarding/url/" + providerId,
      successHandler: function(result) {
        setIsLoaded(true);
        setData(result);
      },
      errorHandler: function(error) {
        setIsLoaded(true);
        setError(error);
      }
    });
  }, [providerId, refresh])

  if (canEdit && !error && isLoaded && (!data || !data.url))
  {
    return (
      <>
        <ProviderOnboarding isCreated={false} sendOnboardingForms={sendOnboardingForms} setSendOnboardingForms={setSendOnboardingForms} createInitialEnrollmentTasks={createInitialEnrollmentTasks} setCreateInitialEnrollmentTasks={setCreateInitialEnrollmentTasks} createPsvTasks={createPsvTasks} setCreatePsvTasks={setCreatePsvTasks} onESignatureTemplatesChanged={onESignatureTemplatesChanged} canEdit={true}/>
      </>
    )
  }

  var url;

  if (error)
  {
    url = <tr><td>Error... please reload the page...</td></tr>;
  }
  else if (!isLoaded)
  {
    url = <tr><td>Loading...</td></tr>;
  }
  else if (!data || !data.url)
  {
      // No edit access
      url= <tr><td>No active onboarding link</td></tr>;
  }
  else
  {
    url = <tr><td><a href={data.url} target="_blank"><ExternalLink style={{'height': '16px', 'width': '16px'}}/>&nbsp;Active onboarding link</a><br /><br /></td></tr>;
  }

  return (
    <Card>
      <Card.Header style={{marginBottom: '-15px'}}>
        <Card.Title>
        Onboarding / Initial Build
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Table>
          <tbody>
            {url}
          </tbody>
        </Table>
      </Card.Body>
  </Card>
  )
}

const AvailablePractice = ({ id, name, isMember, isPrimary, startDate, endDate, contractType, defaultTaskAssigneeId, defaultTaskAssigneeName, existingProvider, onChange, canEdit }) => {
  const [localIsMember, setLocalIsMember] = useState(isMember);
  const [localIsPrimary, setLocalIsPrimary] = useState(isPrimary);
  const [localStartDate, setLocalStartDate] = useState(startDate);
  const [localEndDate, setLocalEndDate] = useState(endDate);
  const [localContractType, setLocalContractType] = useState(contractType ? contractType : "");

  const handleIsMemberChanged = (e) => {
    // Prevent default here actually prevents the box from checking/unchecking

    if (existingProvider && isMember && !e.target.checked)
    {
      if (!window.confirm("Removing this provider's membership from " + name + " will delete any carrier and business line participation data for this TIN + NPI; any associated active tasks will be archived as well (upon clicking 'Save').  Are you sure you want continue?"))
      {
        return;
      }

      // Make it clear that we're wiping expires too (since server actually deletes this row)
      setLocalStartDate(null);
      setLocalEndDate(null);
      setLocalIsPrimary(false);
      setLocalContractType("");
      setLocalAssignees(null);
    }

    setLocalIsMember(e.target.checked);
    onChange(id, e.target.checked, localIsPrimary, localStartDate, localEndDate, localContractType ? localContractType : null, localAssignees ? (localAssignees.value ? localAssignees.value : null) : null);
  }

  const handleIsPrimaryChanged = (e) => {
    setLocalIsPrimary(e.target.checked);
    onChange(id, localIsMember, e.target.checked, localStartDate, localEndDate, localContractType ? localContractType : null, localAssignees ? (localAssignees.value ? localAssignees.value : null) : null);
  }

  const handleStartDateChanged = (date, e) => {
    e.preventDefault();
  
    // If they clear it out, date picker sends it back as "", not null
    if (date === "")
    {
      date = null;
    }

    setLocalStartDate(date);
    onChange(id, localIsMember, localIsPrimary, date, localEndDate, localContractType ? localContractType : null, localAssignees ? (localAssignees.value ? localAssignees.value : null) : null);
  }

  const handleEndDateChanged = (date, e) => {
    e.preventDefault();
  
    // If they clear it out, date picker sends it back as "", not null
    if (date === "")
    {
      date = null;
    }

    setLocalEndDate(date);
    onChange(id, localIsMember, localIsPrimary, localStartDate, date, localContractType ? localContractType : null, localAssignees ? (localAssignees.value ? localAssignees.value : null) : null);
  }

  const handleContractTypeChanged = (contractType, e) => {
    e.preventDefault();

    setLocalContractType(contractType);
    onChange(id, localIsMember, localIsPrimary, localStartDate, localEndDate, contractType ? contractType : null, localAssignees ? (localAssignees.value ? localAssignees.value : null) : null);
  }

  let formattedAssignees = null;  // Null to allow task select to auto-select first assignee
  if (defaultTaskAssigneeId != null && defaultTaskAssigneeId !== 0 && defaultTaskAssigneeName)
  {
    formattedAssignees = {value: defaultTaskAssigneeId, label: defaultTaskAssigneeName};
  }
  const [localAssignees, setLocalAssignees] = useState(formattedAssignees);

  const handleAssigneesChanged = (assignees) => {
    setLocalAssignees(assignees);

    onChange(id, localIsMember, localIsPrimary, localStartDate, localEndDate, localContractType ? localContractType : null, assignees ? (assignees.value ? assignees.value : null) : null);
  }

  return (
    <tr>
        <td>{name}</td>
        <td><Form.Check checked={localIsMember} disabled={!canEdit} onChange={(e) => {handleIsMemberChanged(e)}} /></td>
        <td><Form.Check disabled={!canEdit || !localIsMember} type="checkbox" checked={localIsPrimary} onChange={(e) => {handleIsPrimaryChanged(e)}} /></td>
        <td style={{minWidth: '160px', height: '70px'}}><EditableExpires display="inline" size="lg" width="125px" warnWithColors={false} localExpires={localStartDate} localActive={localIsMember} editingExpires={canEdit} handleExpiresChanged={handleStartDateChanged} /></td>
        {existingProvider &&
        <td ><EditableExpires display="inline" size="lg" width="125px" warnWithColors={false} localExpires={localEndDate} localActive={localIsMember} editingExpires={canEdit} handleExpiresChanged={handleEndDateChanged} /></td>
        }
        <td>
          <Form.Select style={{minWidth: '100px', height:'38px'}} disabled={!canEdit || !localIsMember} onChange={(e) => {handleContractTypeChanged(e.target.value, e)}} value={localContractType}>
            <option value="" key=""></option>
            <option value="SERVICE" key="SERVICE">Services</option>
            <option value="SAAS" key="SAAS">SaaS</option>
            <option value="PAY_AS_YOU_GO" key="PAY_AS_YOU_GO">Pay-As-You-Go</option>
          </Form.Select>
        </td>
        <td style={{minWidth: '185px'}}><TaskAssigneeSelect disabled={!canEdit || !localIsMember} selectedAssignees={localAssignees} handleAssigneesChanged={handleAssigneesChanged} isMulti={false} /></td>
    </tr>
  );
}

const ProviderPracticeAssignment = ({providerId, onPracticeChanged, canEdit, refresh}) => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);

  const existingProvider = providerId > 0;

  useEffect(() => {
    authenticatedFetch({
      path: providerId && providerId > 0 ? "admin/provider/practices/" + providerId : "admin/provider/practices/",
      successHandler: function(result) {
        setIsLoaded(true);
        setData(result);

        for (var i = 0; i < result.length; i++)
        {
          onPracticeChanged(result[i].id, result[i].isMember, result[i].isPrimary, result[i].startDate, result[i].endDate, result[i].contractType, result[i].defaultTaskAssigneeId);
        }
      },
      errorHandler: function(error) {
        setIsLoaded(true);
        setError(error);
      }
    });
  }, [providerId, refresh])

  var practiceList;

  if (error)
  {
    practiceList = <tr><td colSpan={existingProvider ? 7 : 6}>Error... please try again...</td></tr>;
  }
  else if (!isLoaded)
  {
    practiceList = <tr><td colSpan={existingProvider ? 7 : 6}>Loading...</td></tr>;
  }
  else if (!data || data.length === 0)
  {
    practiceList = <tr><td colSpan={existingProvider ? 7 : 6}>No practices found...</td></tr>;
  }
  else
  {
    practiceList = data.map((practice) => {
      return (
        <AvailablePractice key={practice.id} id={practice.id} name={practice.name} isMember={practice.isMember} isPrimary={practice.isPrimary} startDate={practice.startDate} endDate={practice.endDate} contractType={practice.contractType} defaultTaskAssigneeId={practice.defaultTaskAssigneeId} defaultTaskAssigneeName={practice.defaultTaskAssigneeName} existingProvider={existingProvider} onChange={onPracticeChanged} canEdit={canEdit}/>
      )
    }, this);
  }

  return (
    <Card>
      <Card.Header style={{marginBottom: '-15px'}}>
        <Card.Title>
        Practice Associations
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Table striped hover>
          <thead>
            <tr>
              <td>Name</td>
              <td>Member</td>
              <td>Primary</td>
              <td>Start Date</td>
              {existingProvider &&
              <td>End Date</td>
              }
              <td>Contract Type Override</td>
              <td>Auto. Task Assignee Override</td>
            </tr>
          </thead>
          <tbody>
            {practiceList}
          </tbody>
        </Table>
      </Card.Body>
  </Card>
  )
}

const ProviderCreation = ({onCancel, onSuccess}) => {
  const [npi, setNpi] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddletName] = useState("");
  const [lastName, setLastName] = useState("");
  const [credentials, setCredentials] = useState("");
  const [email, setEmail] = useState("");
  const [sendOnboardingForms, setSendOnboardingForms] = useState(false);

  const [localHubData, setLocalHubData] = useState({})
  const [localReminderPreferenceData, setLocalReminderPreferenceData] = useState({})
  const [localPracticeData, setLocalPracticeData] = useState({});
  const [localESignatureTemplates, setLocalESignatureTemplates] = useState({});

  const[isSaving, setIsSaving] = useState(false);

  const notyf = useContext(NotyfContext);

  const onHubChanged = (hubId, isActive) => {
    localHubData[hubId] = isActive;
    setLocalHubData(localHubData);
  }

  const onReminderPreferenceChanged = (reminderPreferenceId, isActive) => {
    localReminderPreferenceData[reminderPreferenceId] = isActive;
    setLocalReminderPreferenceData(localReminderPreferenceData);
  }

  const onPracticeChanged =  (practiceId, isMember, isPrimary, startDate, endDate, contractType, defaultTaskAssigneeId) => {
    localPracticeData[practiceId] = {isMember: isMember, isPrimary: isPrimary, startDate: startDate, endDate: endDate, contractType: contractType, defaultTaskAssigneeId: defaultTaskAssigneeId};
    setLocalPracticeData(localPracticeData);
  }

  const onESignatureTemplatesChanged = (templateId, isIncluded) => {
    localESignatureTemplates[templateId] = isIncluded;
    setLocalESignatureTemplates(localESignatureTemplates);
  }

  const doSave = (e) => {
    setIsSaving(true);
    authenticatedFetch({
      method: "POST",
      path:  "admin/provider/",
      requestData: {
        npi: npi,
        firstName: firstName,
        middleName: middleName,
        lastName: lastName,
        credentials: credentials,
        email: email,
        sendOnboardingForms: sendOnboardingForms,
        dataHubs: localHubData,
        reminderPreferences: localReminderPreferenceData,
        practiceAssociations: localPracticeData,
        includedESignatureTemplates: localESignatureTemplates,
      },
      successHandler: function(result) {
        setIsSaving(false);
        notyf.open({type: "success", message: "Provider created!", duration: 5000, dismissable: true, ripple: true, background: '#3AAFA9'});
        onSuccess();
      },
      errorHandler: function(error) {
        setIsSaving(false);
        notyf.open({type: "error", message: "Something went wrong; please try again", duration: 5000, dismissable: true, ripple: true});
      }
    });
  }

  const handleSave = (e) => {
    e.preventDefault();

    if (isSaving)
    {
      return;
    }

    if (!firstName || firstName.length === 0 || !lastName || lastName.length === 0 || (sendOnboardingForms && (!email || email.length === 0)))
    {
      if (sendOnboardingForms)
      {
        alert("First name, last name, and email are required to add a new provider to Elevate.")
      }
      else
      {
        alert("First name and last name are required to add a new provider to Elevate.")
      }

      
      return;
    }

    var practiceMembership = false;
    for (var practiceId in localPracticeData)
    {
      if (localPracticeData[practiceId] && localPracticeData[practiceId].isMember)
      {
        practiceMembership = true;
        break;
      }
    }

    if (!practiceMembership)
    {
      alert("At least one practice must be selected for membership.")
      return;
    }    

    if (sendOnboardingForms)
    {
        let activePracticeIds = Object.keys(localPracticeData).filter((key) => localPracticeData[key].isMember);

        authenticatedFetch({
          path: "admin/provider/onboarding/check/?practiceIds=" + activePracticeIds,
          successHandler: function(result) {
            if (result.errors.length > 0)
            {
              alert("Please address the following issues before sending onboarding link:\n\n" + result.errors.join("\n\n"));
            }
            else
            {
              doSave();
            }
          },
          errorHandler: function(error) {
            alert("Something went wrong; please try again");
          }
        });
    }
    else
    {
      doSave();
    }
  }

  return (
    <>
      <Row>
        <Col lg="6">
          <ProviderBasicFields npi={npi} setNpi={setNpi} firstName={firstName} setFirstName={setFirstName} middleName={middleName} setMiddletName={setMiddletName} lastName={lastName} setLastName={setLastName} credentials={credentials} setCredentials={setCredentials} email={email} setEmail={setEmail} sendOnboardingForms={sendOnboardingForms} />
        </Col>
        <Col lg="6">
          <ProviderOnboarding isCreate={true} sendOnboardingForms={sendOnboardingForms} setSendOnboardingForms={setSendOnboardingForms} onESignatureTemplatesChanged={onESignatureTemplatesChanged} canEdit={true}/>
        </Col>
      </Row>
      <Row>
        <Col lg="5">
          <ProviderHubAssignment onHubChanged={onHubChanged} canEdit={true}/>
          <ReminderPreferenceAssignment entityType="provider" onReminderPreferenceChanged={onReminderPreferenceChanged} canEdit={true}/>
        </Col>
        <Col lg="7">
          <ProviderPracticeAssignment onPracticeChanged={onPracticeChanged} canEdit={true}/>
        </Col>
      </Row>
      <br />
      <Row>
        <Col lg="12">
          { isSaving ?
            <Spinner animation="border" size="sm" variant="primary" style={{marginLeft: '15px'}}/>
          :
          <>
            <Button onClick={(e) => {handleSave(e)}}>Add</Button>
            &nbsp;&nbsp;
            <Button variant="secondary" onClick={(e) => {onCancel(e)}}>Cancel</Button>
          </>
          }
        </Col>
      </Row>
    </>
  )
};

const ProviderUpdate = ({providerId, onCancel, canEdit, onRemove}) => {
  
  const[isSaving, setIsSaving] = useState(false);

  // Have to duplicate this to get the state up high enough
  const [localHubData, setLocalHubData] = useState({})
  const [localReminderPreferenceData, setLocalReminderPreferenceData] = useState({});
  const [localPracticeData, setLocalPracticeData] = useState({});
  const [localESignatureTemplates, setLocalESignatureTemplates] = useState({});
  const [sendOnboardingForms, setSendOnboardingForms] = useState(false);
  const [createInitialEnrollmentTasks, setCreateInitialEnrollmentTasks] = useState(false);
  const [createPsvTasks, setCreatePsvTasks] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(0);

  const notyf = useContext(NotyfContext);

  const onHubChanged = (hubId, isActive) => {
    localHubData[hubId] = isActive;
    setLocalHubData(localHubData);
  }

  const onReminderPreferenceChanged = (reminderPreferenceId, isActive) => {
    localReminderPreferenceData[reminderPreferenceId] = isActive;
    setLocalReminderPreferenceData(localReminderPreferenceData);
  }

  const onPracticeChanged =  (practiceId, isMember, isPrimary, startDate, endDate, contractType, defaultTaskAssigneeId) => {
    localPracticeData[practiceId] = {isMember: isMember, isPrimary: isPrimary, startDate: startDate, endDate: endDate, contractType: contractType, defaultTaskAssigneeId: defaultTaskAssigneeId};
    setLocalPracticeData(localPracticeData);
  }

  const onESignatureTemplatesChanged = (templateId, isIncluded) => {
    localESignatureTemplates[templateId] = isIncluded;
    setLocalESignatureTemplates(localESignatureTemplates);
  }

  const doSave = (e) => {
    setIsSaving(true);

    authenticatedFetch({
      method: "PUT",
      path:  "admin/provider/" + providerId,
      requestData: {
        dataHubs: localHubData,
        reminderPreferences: localReminderPreferenceData,
        practiceAssociations: localPracticeData,
        sendOnboardingForms: sendOnboardingForms,
        createInitialEnrollmentTasks: createInitialEnrollmentTasks,
        createPsvTasks: createPsvTasks,
        includedESignatureTemplates: localESignatureTemplates,
      },
      successHandler: function(result) {
        setIsSaving(false);
        setCreateInitialEnrollmentTasks(false);
        setCreatePsvTasks(false);
        setForceRefresh(forceRefresh + 1);
        window.scrollTo(0, 0);
        notyf.open({type: "success", message: "Provider updated!", duration: 5000, dismissable: true, ripple: true, background: '#3AAFA9'});
      },
      errorHandler: function(error) {
        setIsSaving(false);
        notyf.open({type: "error", message: "Something went wrong; please try again", duration: 5000, dismissable: true, ripple: true});
      }
    });
  }

  const handleSave = (e) => {
    e.preventDefault();

    // Check for end-dated practice(s) case... need to add another one before saving (or sending onboarding link)
    var practiceMembership = false;
    for (var practiceId in localPracticeData)
    {
      if (localPracticeData[practiceId] && localPracticeData[practiceId].isMember)
      {
        practiceMembership = true;
        break;
      }
    }

    if (!practiceMembership)
    {
      alert("At least one practice must be selected for membership.")
      return;
    }

    if (sendOnboardingForms && (createInitialEnrollmentTasks || createPsvTasks))
    {
      alert("Those tasks will get created automatically when the provider submits their onboarding, so you don't need to select those options here.");
      setCreateInitialEnrollmentTasks(false);
      setCreatePsvTasks(false);
      return;
    }

    if (sendOnboardingForms && !window.confirm("Are you sure you want to send new onboarding link to this provider? This will grant them the ability to edit data from various sections of their profile, including peer references, work history, etc."))
    {
      return;
    }

    if (sendOnboardingForms)
    {
        let activePracticeIds = Object.keys(localPracticeData).filter((key) => localPracticeData[key].isMember);

        authenticatedFetch({
          path: "admin/provider/onboarding/check/?practiceIds=" + activePracticeIds + "&providerId=" + providerId,
          successHandler: function(result) {
            if (result.errors.length > 0)
            {
              alert("Please address the following issues before sending onboarding link:\n\n" + result.errors.join("\n\n"));
            }
            else
            {
              doSave();
            }
          },
          errorHandler: function(error) {
            alert("Something went wrong; please try again");
          }
        });
    }
    else
    {
      doSave();
    }
  }

  const handleRemove = (e) => {
    if (!window.confirm("Are you sure you want to delete this provider?  Any associated active tasks will be archived and you will no longer have access to the provider's details or historical information. "))
    {
      return;
    }

    setIsSaving(true);

    authenticatedFetch({
      method: "DELETE",
      path:  "admin/provider/" + providerId,
      successHandler: function(result) {
        setIsSaving(false);
        notyf.open({type: "success", message: "Provider deleted!", duration: 5000, dismissable: true, ripple: true, background: '#3AAFA9'});
        onRemove();
      },
      errorHandler: function(error) {
        setIsSaving(false);
        notyf.open({type: "error", message: "Something went wrong; please try again", duration: 5000, dismissable: true, ripple: true});
      }
    });
  }
  
  return (
    <>
    <Row>
      <Col lg="4">
        <ProviderHubAssignment providerId={providerId} onHubChanged={onHubChanged} canEdit={canEdit} refresh={forceRefresh}/>
        <ReminderPreferenceAssignment entityType="provider" id={providerId} onReminderPreferenceChanged={onReminderPreferenceChanged} canEdit={canEdit} refresh={forceRefresh}/>
        <ProviderOnboardingUrl providerId={providerId} sendOnboardingForms={sendOnboardingForms} setSendOnboardingForms={setSendOnboardingForms} createInitialEnrollmentTasks={createInitialEnrollmentTasks} setCreateInitialEnrollmentTasks={setCreateInitialEnrollmentTasks} createPsvTasks={createPsvTasks} setCreatePsvTasks={setCreatePsvTasks} onESignatureTemplatesChanged={onESignatureTemplatesChanged} canEdit={canEdit} refresh={forceRefresh}/>
      </Col>
      <Col lg="8">
        <ProviderPracticeAssignment providerId={providerId} onPracticeChanged={onPracticeChanged} canEdit={canEdit} refresh={forceRefresh}/>
      </Col>
    </Row>
    <br />
    <Row>
      <Col lg="12">
        { isSaving ?
          <Spinner animation="border" size="sm" variant="primary" style={{marginLeft: '15px'}}/>
        :
        <>
          {canEdit && <Button onClick={(e) => {handleSave(e)}}>Save</Button>}
          &nbsp;&nbsp;
          <Button variant="secondary" onClick={(e) => {onCancel(e)}}>Cancel</Button>
          {canEdit && <Button variant="danger" className="float-end" onClick={(e) => {handleRemove(e)}}><Trash2 style={{'height': '14px', 'width': '14px'}}/>&nbsp;Delete Provider</Button>}
        </>
        }
      </Col>
    </Row>
    </>
  );
};


const ProviderPicker = ({onProviderChanged, isLoaded, error, data}) => {
  var providerList;
  if (!isLoaded)
  {
    providerList = [<option value={0} key={0}>Loading...</option>];
  }
  else if (error || !data)
  {
    providerList = [<option value={0} key={0}>Error... Please reload the page...</option>];
  }
  else
  {
    providerList = [<option value={0} key={0}>Select a provider...</option>];
    providerList.push(data.map((provider, i) => {
      return (
        <option value={provider.id} key={provider.id}>{provider.formattedName}</option>
      )
    }, this));
  }

  return (
    <Row className="float-start">
      <Col lg="12">
        <Form.Select onChange={(e) => {onProviderChanged(e)}} style={{width: "500px"}} >
          {providerList}
        </Form.Select>
      </Col>
    </Row>
  )
};

const ProviderSelect = ({ handleProviderChanged, selectedProviders, onlyOnboardingEligible, onlyBulkTaskEligible}) => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
      authenticatedFetch({
          path: "admin/provider/providers?onlyOnboardingEligible=" + onlyOnboardingEligible + "&onlyBulkTaskEligible=" + onlyBulkTaskEligible,
              successHandler: function(result) {
              setIsLoaded(true);
              setData(result);
          },
          errorHandler: function(error) {
              setIsLoaded(true);
              setError(error);
          }
      });
  }, [onlyOnboardingEligible, onlyBulkTaskEligible])

  const options = data.map((provider) => {
      return {value: provider.id, label: provider.formattedName};
  });

  if (!isLoaded)
  {
    return (<Form.Select disabled={true}><option value={0} key={0}>Loading...</option></Form.Select>);
  }
  else if (error || !data)
  {
    return (<Form.Select disabled={true}><option value={0} key={0}>Error... Please reload the page...</option></Form.Select>);
  }
  else
  {
      return (
          <div style={{width: "350px"}}>
              <Select
              options={options}
              onChange={(selectedProviders) => {
                  handleProviderChanged(selectedProviders);
              }}
              value={selectedProviders}
              placeholder="Select providers..."
              isMulti
              theme={(theme) => ({
                ...theme,
                colors: {
                ...theme.colors,
                  primary50: '#DEF2F1',
                  primary25: '#DEF2F1',
                  primary: '#3AAFA9',
                },
              })}
              />
          </div>
      )
  }
}


const BulkOnboardingModal = ({ show, onClose}) => {
  const [providerIds, setProviderIds] = useState([]);
  const [selectedProviders, setSelectedProviders] = useState([]);
  const [localESignatureTemplates, setLocalESignatureTemplates] = useState({});
  const [isSending, setIsSending] = useState(false);

  const notyf = useContext(NotyfContext);

  const handleProviderChanged = (providers, e) => {
      setSelectedProviders(providers);

      let newProviderIds = []
      for (var i=0; i<providers.length; i++)
      {
          newProviderIds.push(providers[i].value);
      }

      setProviderIds(newProviderIds);
  }

  const reset = () => {
      setProviderIds([]);
      setSelectedProviders([]);
      setLocalESignatureTemplates({});
  }

  const handleClose = () => {
      reset();
      onClose();
  }

  const onESignatureTemplatesChanged = (templateId, isIncluded) => {
    localESignatureTemplates[templateId] = isIncluded;
    setLocalESignatureTemplates(localESignatureTemplates);
  }

  const handleSendClicked = (e) => {
      e.preventDefault();

      if (!window.confirm("Send onboarding links to " + providerIds.length + " provider" + (providerIds.length > 1 ? "s" : "") + "?"))
      {
          return;
      }

      setIsSending(true);
  
      authenticatedFetch({
        method: "POST",
        path:  "admin/provider/onboarding/bulk",
        requestData: {
          providerIds: providerIds,
          includedESignatureTemplates: localESignatureTemplates,
        },
        successHandler: function(result) {
          setIsSending(false);
          notyf.open({type: "success", message: "Onboarding links are sending!", duration: 5000, dismissable: true, ripple: true, background: '#3AAFA9'});
          handleClose();
        },
        errorHandler: function(error) {
          setIsSending(false);
          notyf.open({type: "error", message: "Something went wrong; please try again", duration: 5000, dismissable: true, ripple: true});
        }
      });
  }
  
  
  return (
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton style={{backgroundColor: '#DEF2F1'}}>
          <Modal.Title>
            <span style={{fontSize: "0.9em", fontWeight: "normal"}}>Bulk Send Onboarding Links</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span className="text-muted">Note: only providers with a valid email address, no active onboarding link, and who are associated with practices which meet all data requirements are eligible here.</span>
          <br /><br />
          <Table> 
            <tbody>
              <tr>
                  <td>Provider(s):</td>
                  <td><ProviderSelect handleProviderChanged={handleProviderChanged} selectedProviders={selectedProviders} onlyOnboardingEligible={true} onlyBulkTaskEligible={false}/></td>
              </tr>
              <tr>
                <td colSpan={2}><AvailableESignatureTemplates pathPrefix="admin/provider" onESignatureTemplatesChanged={onESignatureTemplatesChanged} canEdit={true}/></td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer style={{backgroundColor: '#DEF2F1'}}>
        {isSending ? 
            <Spinner animation="border" size="sm" variant="primary" className="float-end" style={{marginRight: '15px', marginTop: '11px', marginBottom: '11px'}}/>
          :
          <>
            <Button onClick={handleClose}>Close</Button>
            <Button onClick={(e) => {handleSendClicked(e)}} disabled={providerIds.length === 0}>Send</Button>
          </>
          }
        </Modal.Footer>
      </Modal>
  );
}

const BulkTasksModal = ({ show, onClose}) => {
  const [providerIds, setProviderIds] = useState([]);
  const [selectedProviders, setSelectedProviders] = useState([]);
  const [assignees, setAssignees] = useState(null);
  const [createInitialEnrollmentTasks, setCreateInitialEnrollmentTasks] = useState(false);
  const [createPsvTasks, setCreatePsvTasks] = useState(false);

  const [isProcessing, setIsProcessing] = useState(false);

  const notyf = useContext(NotyfContext);

  const handleProviderChanged = (providers, e) => {
      setSelectedProviders(providers);

      let newProviderIds = []
      for (var i=0; i<providers.length; i++)
      {
          newProviderIds.push(providers[i].value);
      }

      setProviderIds(newProviderIds);
  }

    const handleAssigneesChanged = (assignees) => {
        setAssignees(assignees);
    }

  const reset = () => {
      setProviderIds([]);
      setSelectedProviders([]);
      setAssignees(null);
  }

  const handleClose = () => {
      reset();
      onClose();
  }

  const handleGenerateClicked = (e) => {
      e.preventDefault();

      if (!window.confirm("Generate tasks for " + providerIds.length + " provider" + (providerIds.length > 1 ? "s" : "") + "?"))
      {
          return;
      }

      setIsProcessing(true);
  
      authenticatedFetch({
        method: "POST",
        path:  "admin/provider/tasks/bulk",
        requestData: {
          providerIds: providerIds,
          assignees: assignees,
          createInitialEnrollmentTasks: createInitialEnrollmentTasks,
          createPsvTasks: createPsvTasks
        },
        successHandler: function(result) {
          setIsProcessing(false);
          notyf.open({type: "success", message: "Tasks are generating!", duration: 5000, dismissable: true, ripple: true, background: '#3AAFA9'});
          handleClose();
        },
        errorHandler: function(error) {
          setIsProcessing(false);
          notyf.open({type: "error", message: "Something went wrong; please try again", duration: 5000, dismissable: true, ripple: true});
        }
      });
  }
  
  
  return (
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton style={{backgroundColor: '#DEF2F1'}}>
          <Modal.Title>
            <span style={{fontSize: "0.9em", fontWeight: "normal"}}>Bulk Generate Tasks</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span className="text-muted">Note: only providers with no active onboarding link are eligible here.</span>
          <br /><br />
          <Table> 
            <tbody>
              <tr>
                  <td>Provider(s):</td>
                  <td><ProviderSelect handleProviderChanged={handleProviderChanged} selectedProviders={selectedProviders} onlyOnboardingEligible={false} onlyBulkTaskEligible={true}/></td>
              </tr>
              <tr>
                <td>Assignee(s):</td>
                <td><TaskAssigneeSelect autoSelectFirstAssignee={true} disabled={false} selectedAssignees={assignees} handleAssigneesChanged={handleAssigneesChanged} /></td>
              </tr>
              <tr>
                <td>Create Initial Enrollment Tasks</td>
                <td><Form.Check type="switch" checked={createInitialEnrollmentTasks} style={{display: "inline"}}  onChange={(e) => {setCreateInitialEnrollmentTasks(e.target.checked)}}/></td>
              </tr>
              <tr>
                <td>Create PSV Tasks</td>
                <td><Form.Check type="switch" checked={createPsvTasks} style={{display: "inline"}}  onChange={(e) => {setCreatePsvTasks(e.target.checked)}}/></td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer style={{backgroundColor: '#DEF2F1'}}>
        {isProcessing ? 
            <Spinner animation="border" size="sm" variant="primary" className="float-end" style={{marginRight: '15px', marginTop: '11px', marginBottom: '11px'}}/>
          :
          <>
            <Button onClick={handleClose}>Close</Button>
            <Button onClick={(e) => {handleGenerateClicked(e)}} disabled={providerIds.length === 0 || (!createInitialEnrollmentTasks && !createPsvTasks) || (assignees === null || assignees.length === 0)}>Generate</Button>
          </>
          }
        </Modal.Footer>
      </Modal>
  );
}

const ProviderManagement = () => {

  const [providerId, setProviderId] = useState(0);
  const [providerName, setProviderName] = useState(null);
  
  const [addingNewProvider, setAddingNewProvider] = useState(false);

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);

  const [showBulkOnboardingModal, setShowBulkOnboardingModal] = useState(false);
  const [showBulkTasksModal, setShowBulkTasksModal] = useState(false);

  const { isH3Admin, authorities, navbarRefresh, setNavbarRefresh } = useContext(UserSettingsContext);
  const canEdit = isH3Admin || authorities.includes("ADMIN_PROVIDER_MANAGEMENT_EDIT");

  useEffect(() => {
    reloadList();
  }, []);


  const reloadList= () => {
    authenticatedFetch({
      path: "admin/provider/providers",
      successHandler: function(result) {
        setIsLoaded(true);
        setData(result);
      },
      errorHandler: function(error) {
        setIsLoaded(true);
        setError(error);
      }
    });
  }

  const onProviderChanged = (e) => {
    e.preventDefault();
    setProviderId(e.target.value);
    setProviderName(e.target.options[e.target.selectedIndex].text)
  }

  const handleBack= (e) => {
    e.preventDefault();
    setProviderId(0);
    setProviderName(null);
    setAddingNewProvider(false);
  }

  const handleAddNewProvider= (e) => {
    e.preventDefault();
    setProviderId(0);
    setProviderName(null);
    setAddingNewProvider(true);
  }

  const handleCreateSuccess= () => {
    setProviderId(0);
    setProviderName(null);
    setAddingNewProvider(false);
    reloadList();
    setNavbarRefresh(navbarRefresh + 1);
  }

  const handleRemove= () => {
    setProviderId(0);
    setProviderName(null);
    setAddingNewProvider(false);
    reloadList();
    setNavbarRefresh(navbarRefresh + 1);
  }

  var title = "Provider Management";
  var helmetTitle = title;
  if (providerId > 0)
  {
    title = <>Provider Management | <a href={"/provider/" + providerId}>{providerName}</a></>
    helmetTitle = "Provider Management | " + providerName;
  }
  else if (addingNewProvider)
  {
    title = "Provider Management | Add New Provider";
    helmetTitle = title;
  }

  return (
    <React.Fragment>
      <Helmet title={helmetTitle}/>
      <h1 className="h3 mb-3">{title} 
      
      {!addingNewProvider && providerId === 0 && canEdit &&
      <>
        <Card className="float-end">
          <Card.Header style={{marginBottom: '-15px'}}>
            <Card.Title>
            Tools
            </Card.Title>
          </Card.Header>
          <Card.Body>
            <Table>
              <tbody>
                <tr>
                  <td>
                    <Button size="sm" className="btn btn-primary" onClick={(e) => {handleAddNewProvider(e)}}><UserPlus className="feather" />&nbsp;&nbsp;Add New Provider</Button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Button size="sm" className="btn btn-primary" onClick={() => setShowBulkOnboardingModal(true)}><Send className="feather" />&nbsp;&nbsp;Bulk Send Onboarding Links</Button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Button size="sm" className="btn btn-primary" onClick={() => setShowBulkTasksModal(true)}><Clipboard className="feather" />&nbsp;&nbsp;Bulk Generate Tasks</Button>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Card.Body>
        </Card>
        <BulkOnboardingModal show={showBulkOnboardingModal} onClose={() => setShowBulkOnboardingModal(false)} />
        <BulkTasksModal show={showBulkTasksModal} onClose={() => setShowBulkTasksModal(false)} />
      </>
      }
      </h1>
      
      {(providerId > 0 && data.length > 1) || addingNewProvider ? <><Button variant="secondary" size="sm" onClick={(e) => {handleBack(e)}}>&lt; Back</Button><br /><br /></> : <></>}
      
      {addingNewProvider ? 
        <ProviderCreation onCancel={handleBack} onSuccess={handleCreateSuccess}/> 
        :
        <>
        <Container fluid className="p-0">
          { providerId > 0 ? <></> : <ProviderPicker isLoaded={isLoaded} error={error} data={data} onProviderChanged={onProviderChanged} /> }    
        </Container>

        {providerId > 0 && <ProviderUpdate providerId={providerId} onCancel={handleBack} onRemove={handleRemove} canEdit={canEdit}/>}
      </>
      }
    </React.Fragment>
  )
};

export default ProviderManagement;
